import React, { useEffect } from "react";
import cl from "./RefundPolicy.module.css";
import { animateScroll as scroll } from "react-scroll";

const RefundPolicy = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_policy}>
      <h1>Política de Reembolso</h1>
      <p>Última actualización: 07 de febrero de 2024</p>
      <h2>Cancelación</h2>
      <p>
        Aceptamos la cancelación del pedido antes de que el producto sea enviado
        o producido. Si se cancela el pedido, recibirás un reembolso completo.
        No podemos cancelar el pedido si el producto ya ha sido enviado.
      </p>

      <h2>Devoluciones (si corresponde)</h2>
      <p>
        Aceptamos devoluciones de productos. Los clientes tienen derecho a
        solicitar una devolución dentro de los 14 días posteriores a la
        recepción del producto.
        <br />
        Para ser elegible para una devolución, tu artículo debe estar sin usar y
        en el mismo estado en que lo recibiste. También debe estar en el
        embalaje original. Para completar la devolución, se requiere un
        comprobante de compra o una prueba de compra. Por favor, no devuelvas tu
        compra al fabricante o a nuestra estación de tránsito.
      </p>
    </section>
  );
};

export default RefundPolicy;
